import user from '../../Actions/user';
const { types } = user;

const initialState = {
    userData: [],
    certifieds: {
        fileList: [],
        password: ''
    },
    preUserData: null,
    userInfo: null,
    invoiceData: null,
    role: null
};

const userReducer = (state = initialState, action) => {

    switch (action.type) {
        case types.SET_USER_DATA:
            return {
                ...state,
                userData: action.data
            }
        case types.SET_PRE_USER_DATA:
            return {
                ...state,
                preUserData: action.data,
            }
        case types.SET_USER_INFO: {
            return {
                ...state,
                userInfo: action.data,
            }
        }
        case types.SET_INVOICE_DATA:
            return {
                ...state,
                invoiceData: action.data
            }
        case types.SET_ROLE_DATA:
            return {
                ...state,
                role: action.data
            }
        default:
            return state;
    }
}

export default userReducer;